import { combineReducers } from 'redux';
import app from './reducers/app'; // eslint-disable-line
import entities from './reducers/entities';
import feature from './reducers/feature';
import features from './reducers/features';
import config from './reducers/config';
import session from './reducers/session';
import page from './reducers/page';
import storage from './reducers/storage';
import flash from './reducers/flash';
import toast from './reducers/toast';
import team from './reducers/team';
import trigger from './reducers/trigger';
import { routerReducer as routing } from 'react-router-redux';

export default combineReducers({
  app,
  config,
  entities,
  feature,
  features,
  flash,
  page,
  routing,
  session,
  storage,
  toast,
  trigger,
  team
});



// WEBPACK FOOTER //
// ./js/reducers.js